import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M20 28.65h-8a.65.65 0 0 1-.65-.65v-7a.65.65 0 0 1 .65-.65h8a.65.65 0 0 1 .65.65v7a.65.65 0 0 1-.65.65zm-7.35-1.3h6.7v-5.7h-6.7zM2 13.77a.65.65 0 0 1-.62-.45.63.63 0 0 1 .24-.73l14-10a.65.65 0 0 1 .75 0l14.05 9.89a.65.65 0 0 1-.42 1.17l-2 .06a.65.65 0 0 1 0-1.3l-12-8.5-11.91 8.52a.64.64 0 0 1 .53.62.63.63 0 0 1-.63.66h-2z' }),
  React.createElement('path', { d: 'M28 28.65h-4a.65.65 0 0 1-.65-.65V13.65H8.65V28a.65.65 0 0 1-.65.65H4a.65.65 0 0 1-.65-.65V13h1.3v14.35h2.69V13a.65.65 0 0 1 .66-.65h16a.68.68 0 0 1 .46.19.66.66 0 0 1 .19.46v14.35h2.7V13h1.3v15a.65.65 0 0 1-.65.65zM14 8.35h4v1.3h-4z' }),
  React.createElement('path', { d: 'M15.35 21h1.3v3h-1.3z' })
));